module.exports = __webpack_public_path__ + "img/bhs_scholarship_portal1.244747b9.png";